    <div class="card" [class.sticky]="sticky" #stickyCard style="margin-top: 16px;">

    <div class="card-body">


        <h5 i18n="@@ordersummary">Order Summary</h5>
        <div style="">
            <!--            <h5>Shipping & Tax</h5>-->
            <hr *ngIf="this.summary != null">
            <table width="100%" *ngIf="this.summary != null">
                <tr>
                    <td><b i18n="{order_subtotal}">Order Subtotal</b></td>
                    <td class="text-right">
                        <div style="height: 30px;">


                       <div *ngIf="!isLoading">
                           {{current_currency}} {{(summary.totals.subtotal_incl_tax * rate) | number: '.3'}}
                       </div>
                        <div *ngIf="isLoading" class="text-right"><img src="assets/loader.gif"  style="    width: 30px !important;
    margin-right: -10px;" /></div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><label i18n="{order_tax}">Tax</label></td>
                    <td class="text-right">{{(summary.totals.base_tax_amount * rate) | number: this.registry.getSettingByID('price_format')}}</td>
                </tr>
                <tr>
                    <td><label i18n="{order_shipping}">Shipping</label></td>
                    <td class="text-right">{{(summary.totals.shipping_incl_tax * rate) | number: this.registry.getSettingByID('price_format')}}</td>
                </tr>
                <tr>
                    <td><label i18n="{order_discount}">Discount</label></td>
                    <td class="text-right">{{(summary.totals.discount_amount * rate ) | number: this.registry.getSettingByID('price_format')}}</td>
                </tr>


            </table>
            <hr *ngIf="this.summary != null">
            <table width="100%" *ngIf="this.summary != null">
                <tr>
                    <td style="font-weight: bold;font-size: 15px;" i18n="{order_total}">Order Total</td>
                    <td class="text-right">{{current_currency}} {{(this.summary.totals.grand_total * rate) | number: '.3'}}</td>
                </tr>
            </table>

            <br>
            <div class="text-center" *ngIf="!summary"></div>
            <br>
        </div>


        <button *ngIf="summary" i18n="{confirm_and_pay}" [disabled]="!orderReady" (click)="placeOrder()" class="btn btn-primary btn-block">Confirm & Pay</button>

    </div>

</div>
